module.exports = __webpack_public_path__ + "img/aci.d4736d73.svg";